
  import { mapGetters } from 'vuex';

  export default {
    computed: mapGetters('jumbotron', { jumbotron: 'getJumbotron' })
  };
